module.exports = __webpack_public_path__ + "static/media/warn.06e26882.svg";